import React from "react";
import ReactApexChart from "react-apexcharts";
import {
  Card,
  CardHeader,
  CardBody,
  Col,
  Row,
} from "reactstrap";

const SyncStatusChart = ({
  dashboard = {},
}) => {

  const success =
    dashboard.success || 0;

  const failed =
    dashboard.failed || 0;

  const pending =
    dashboard.pending || 0;

  const total =
    dashboard.totalSyncs ||
    success +
      failed +
      pending;

  const options = {
    chart: {
      type: "donut",
      toolbar: {
        show: false,
      },
    },

    labels: [
      "Success",
      "Failed",
      "Pending",
    ],

    colors: [
      "#198754",
      "#dc3545",
      "#ffc107",
    ],

    legend: {
      position: "bottom",
    },

    dataLabels: {
      enabled: true,
    },

    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 250,
          },
        },
      },
    ],
  };

  const series = [
    success,
    failed,
    pending,
  ];

  return (
    <Col xl={8}>
      <Card
        style={{
          height: "100%",
        }}
      >
        <CardHeader>
          <div className="d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">
              Sync Status Analytics
            </h4>

            <span className="badge bg-primary">
              {total} Syncs
            </span>
          </div>
        </CardHeader>

        <CardBody>

          <ReactApexChart
            type="donut"
            height={320}
            options={options}
            series={series}
          />

          <Row className="mt-4 text-center">

            <Col md={3}>
              <h4 className="text-primary">
                {total}
              </h4>

              <small className="text-muted">
                Total
              </small>
            </Col>

            <Col md={3}>
              <h4 className="text-success">
                {success}
              </h4>

              <small className="text-muted">
                Success
              </small>
            </Col>

            <Col md={3}>
              <h4 className="text-danger">
                {failed}
              </h4>

              <small className="text-muted">
                Failed
              </small>
            </Col>

            <Col md={3}>
              <h4 className="text-warning">
                {pending}
              </h4>

              <small className="text-muted">
                Pending
              </small>
            </Col>

          </Row>

          <hr />

          <Row className="text-center">

            <Col md={4}>
              <strong>
                {total > 0
                  ? (
                      (success /
                        total) *
                      100
                    ).toFixed(1)
                  : 0}
                %
              </strong>

              <div className="text-muted">
                Success Rate
              </div>
            </Col>

            <Col md={4}>
              <strong>
                {total > 0
                  ? (
                      (failed /
                        total) *
                      100
                    ).toFixed(1)
                  : 0}
                %
              </strong>

              <div className="text-muted">
                Failure Rate
              </div>
            </Col>

            <Col md={4}>
              <strong>
                {total > 0
                  ? (
                      (pending /
                        total) *
                      100
                    ).toFixed(1)
                  : 0}
                %
              </strong>

              <div className="text-muted">
                Pending Rate
              </div>
            </Col>

          </Row>

        </CardBody>
      </Card>
    </Col>
  );
};

export default SyncStatusChart;